module.exports = __webpack_public_path__ + "img/product-tutorial-2-purple-flower.adc3bd8e.svg";